import { getColor } from 'basic-components';
import { DispatcherEnums } from 'dashboard-services/api/dispatcher';
import { FormulaEnums } from 'dashboard-services/api/formula';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';
import { globalActions } from 'primary-components';

export default (() => {
  const MONITORING_TYPE = {
    FORMULA: {
      label: "Formula",
      value: "formula"
    },
    PIPELINE: {
      label: "Pipeline",
      value: "pipeline"
    }
  }

  const continuePipeline = ({ onContinue, jobId = undefined }) => (dispatch, getState) => {
    const userName = getState().myAccountState.settingsState.userName
    dispatch(globalActions.getToastsStore()).info(
      "Are you sure you want to continue the pipeline?",
      "Continue pipeline",
      {
        withCancel: false,
        confirmText: "Continue",
        confirmAction: () => onContinue({ jobId, payload: { userName } })
          .then(() => dispatch(globalActions.getMessageStore()).success("Pipeline run has been continued."))
      }
    );
  }

  const playPipeline = ({ getPipelineDetails = () => Promise.resolve(), runPipelineManually, pipelineId }) => async dispatch => {
    let isLatest = false;
    const { data, isError } = await getPipelineDetails({ pipelineId });
    if(isError) {
      return;
    }
    isLatest = data?.latest;

    if(isLatest) {
      dispatch(globalActions.getToastsStore()).info(
        "Are you sure you want to run the pipeline?",
        "Run pipeline",
        {
          withCancel: false,
          confirmText: "Run",
          confirmAction: () => runPipelineManually({ pipelineId })
            .then(() => dispatch(globalActions.getMessageStore()).success("Pipeline has been run."))
        }
      )
    } else {
      dispatch(globalActions.getToastsStore()).warning(
        "The pipeline you are trying to execute has more recent version. Do you want to proceed?",
        "Pipeline's version is not latest", 
        {
          withCancel: false,
          confirmText: "Run Pipeline",
          confirmAction: () => runPipelineManually({ pipelineId })
            .then(() => dispatch(globalActions.getMessageStore()).success("Pipeline has been run."))
        }
      )
    }
  }

  const stopPipeline = ({ pipelineId, jobId, onStop }) => dispatch =>
    dispatch(globalActions.getToastsStore()).info(
      "Are you sure you want to terminate the pipeline?",
      "Terminate pipeline",
      {
        withCancel: false,
        confirmText: "Terminate",
        confirmAction: () => 
          onStop({ pipelineId, jobId })
            .then(() => dispatch(globalActions.getMessageStore()).success("Pipeline has been terminated."))
      }
    )

  const getQueueStatusColor = currentStatus => currentStatus === DispatcherEnums.QUEUE_STATUS.ACTIVE ? getColor('green-fresh') : currentStatus === DispatcherEnums.QUEUE_STATUS.PROCESSING ? getColor('blue-bright') : getColor('grey-medium')

  // A formula has no page of its own, so it opens its latest run's details, or its run history when it has not run yet.
  const getFormulaMonitorUrl = ({ baseUrl = undefined, groupName, name, latestRun = undefined }) => latestRun?.jobId
    ? DashboardLinkFactory.dataScience.monitorDetails({
      baseUrl,
      groupName: latestRun.payload?.formulaGroupName || groupName,
      jobId: latestRun.jobId,
      name,
      type: MONITORING_TYPE.FORMULA.label,
      version: latestRun.payload?.formulaVersion || FormulaEnums.FORMULA_VERSION.LATEST
    })
    : DashboardLinkFactory.dataScience.monitorHistory({ baseUrl, groupName, name, type: MONITORING_TYPE.FORMULA.label })

  return {
    MONITORING_TYPE,
    continuePipeline,
    playPipeline,
    stopPipeline,
    getQueueStatusColor,
    getFormulaMonitorUrl
  }
})()
